const filtersName = {
	idsCustomer: "Cliente",
	idsProduct: "Produto",
	idsProductClass: "Tipo Produto",
	initDate: "Data Inicio",
	endDate: "Data Fim",
	idsAccount: "Conta",
	comments: "Observações",
	transactionType: "Tipo Transação",
	idsCategory: "Categoria",
	status: "Status",
	reference: "Referência",
	dateSearch: "Tipo Data",
	monthsSelected: "Mês",
	yearsSelected: "Ano",
	groupingSelected: "Agrupamento",
	quantity: "Estoque",
	idAccount: "Conta"
};

export function filtersActived (params) {
	const filtersKeys = Object.keys(params);
	const keys = (filtersKeys.reduce((acc, key) => {
		const existKey = Boolean(filtersName[key]);
		if (!existKey) return acc;

		const isMultiKey = Array.isArray(params[key]);
		const isValidKey = Boolean((!isMultiKey || params[key].length));
		if (isValidKey) {
			acc.push(filtersName[key]);
		}

		return acc;
	}, []));

	return keys.join(", ");
}